import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState = {
  status:{
    //pageId:status 
  }
}

export const pageSlice = createSlice({
  name: 'page',
  initialState,
  reducers: {
    setStatus: (state,action) => {
      const {pageId,status} = action.payload;
      state.status[pageId] = status;
    }
  },
})

export const { setStatus } = pageSlice.actions;

export default pageSlice.reducer;


export const PageStatus = {
  idle:1,
  loading:2,
  loaded:3 //加载完毕
}